import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d94a12cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "header-icon" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-text" }, [
  /*#__PURE__*/_createElementVNode("h2", null, "小店信息"),
  /*#__PURE__*/_createElementVNode("p", null, "管理您的小店基本信息与配置")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "info-box url-box"
}
const _hoisted_6 = { class: "box-icon" }
const _hoisted_7 = { class: "box-content" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-label" }, "小店访问地址", -1))
const _hoisted_9 = { class: "box-value" }
const _hoisted_10 = { class: "box-action" }
const _hoisted_11 = { class: "info-box balance-box" }
const _hoisted_12 = { class: "box-icon" }
const _hoisted_13 = { class: "box-content" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-label" }, "账户余额", -1))
const _hoisted_15 = { class: "box-value" }
const _hoisted_16 = {
  key: 1,
  class: "pay-mode-notice warning"
}
const _hoisted_17 = { class: "notice-icon warning" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("当前小店为"),
  /*#__PURE__*/_createElementVNode("strong", null, "自定义支付通道"),
  /*#__PURE__*/_createTextVNode("，游客访问小店后，将使用您自定义的支付通道进行支付，请确保余额充足，否则即使支付成功，余额支付开通授权时也会失败。 ")
], -1))
const _hoisted_19 = {
  key: 2,
  class: "pay-mode-notice info"
}
const _hoisted_20 = { class: "notice-icon info" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("当前小店为"),
  /*#__PURE__*/_createElementVNode("strong", null, "系统支付通道"),
  /*#__PURE__*/_createTextVNode("，游客访问小店后，将使用系统支付通道进行支付，您自定义的支付通道不会生效，游客支付授权成功后，将发放反利给您。 ")
], -1))
const _hoisted_22 = { class: "form-section" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-section-title" }, "基本设置", -1))

import { ref, computed, onMounted } from 'vue'
import axios from 'axios'
import { message } from 'ant-design-vue'
import { ShopOutlined, LinkOutlined, WalletOutlined, WarningOutlined, InfoCircleOutlined } from '@ant-design/icons-vue'
import UserHead from '@/components/UserHead.vue'
import UserHeadTop from '@/components/UserHeadTop.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShopInfoView',
  setup(__props) {

const baseURL = process.env.VUE_APP_API_BASE_URL
const headers = { 'token': localStorage.getItem('token') || '' }

const shopInfo = ref({
    id: 0,
    tenant_key: '',
    shop_name: '',
    shop_status: 1,
    shop_desc: '',
    contact: '',
    balance: 0,
    order_pay_mode: '',
})
const saving = ref(false)
const isAdmin = ref(false)

const shopUrl = computed(() => {
    if (!shopInfo.value.tenant_key) return ''
    const origin = window.location.origin
    return `${origin}/shop?tenant_key=${shopInfo.value.tenant_key}`
})

const getShopInfo = async () => {
    try {
        const res = await axios.post(baseURL + '/api/shop/tenant/info', {}, { headers })
        if (res.data.code === 0) {
            shopInfo.value = { ...shopInfo.value, ...res.data.data }
            isAdmin.value = !!res.data.data.is_admin
        } else {
            message.error(res.data.msg || '获取小店信息失败')
        }
    } catch (e: any) {
        message.error('获取小店信息失败：' + e.message)
    }
}

const saveShopInfo = async () => {
    saving.value = true
    try {
        const res = await axios.post(baseURL + '/api/shop/tenant/update', {
            shop_name: shopInfo.value.shop_name,
            shop_status: shopInfo.value.shop_status,
            shop_desc: shopInfo.value.shop_desc,
            contact: shopInfo.value.contact,
            ...(isAdmin.value ? { order_pay_mode: shopInfo.value.order_pay_mode } : {}),
        }, { headers })
        if (res.data.code === 0) {
            message.success('保存成功')
        } else {
            message.error(res.data.msg || '保存失败')
        }
    } catch (e: any) {
        message.error('保存失败：' + e.message)
    } finally {
        saving.value = false
    }
}

const copyText = (text: string) => {
    navigator.clipboard.writeText(text).then(() => {
        message.success('已复制到剪贴板')
    }).catch(() => {
        message.warning('复制失败，请手动复制')
    })
}

const openShop = () => {
    window.open(shopUrl.value, '_blank')
}

onMounted(() => {
    getShopInfo()
})

return (_ctx: any,_cache: any) => {
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_switch = _resolveComponent("a-switch")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: {"min-height":"100vh"} }, {
    default: _withCtx(() => [
      _createVNode(UserHead),
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_layout_header, { style: {"padding":"0","background":"#fff","border-bottom":"1px solid #f0f0f0"} }, {
            default: _withCtx(() => [
              _createVNode(UserHeadTop)
            ]),
            _: 1
          }),
          _createVNode(_component_a_layout_content, { class: "shop-info-content-div" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(ShopOutlined))
                  ]),
                  _hoisted_4
                ]),
                (shopInfo.value.tenant_key)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_unref(LinkOutlined))
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        _hoisted_8,
                        _createElementVNode("div", _hoisted_9, _toDisplayString(shopUrl.value), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_a_button, {
                          size: "small",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (copyText(shopUrl.value)))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("复制")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_a_button, {
                          size: "small",
                          type: "primary",
                          ghost: "",
                          onClick: openShop
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("打开")
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_unref(WalletOutlined))
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", _hoisted_15, "￥" + _toDisplayString(shopInfo.value.balance || '0.00'), 1)
                  ])
                ]),
                (shopInfo.value.order_pay_mode === 'tenant')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_unref(WarningOutlined))
                      ]),
                      _hoisted_18
                    ]))
                  : (shopInfo.value.order_pay_mode === 'system')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createVNode(_unref(InfoCircleOutlined))
                        ]),
                        _hoisted_21
                      ]))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_22, [
                  _hoisted_23,
                  _createVNode(_component_a_form, {
                    model: shopInfo.value,
                    layout: "vertical"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, { label: "小店名称" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: shopInfo.value.shop_name,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((shopInfo.value.shop_name) = $event)),
                            placeholder: "请输入小店名称"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "小店状态" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_switch, {
                            checked: shopInfo.value.shop_status,
                            "onUpdate:checked": _cache[2] || (_cache[2] = ($event: any) => ((shopInfo.value.shop_status) = $event)),
                            "checked-value": 1,
                            "un-checked-value": 0,
                            "checked-children": "营业中",
                            "un-checked-children": "已关闭"
                          }, null, 8, ["checked"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "小店简介" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_textarea, {
                            value: shopInfo.value.shop_desc,
                            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((shopInfo.value.shop_desc) = $event)),
                            rows: 3,
                            "show-count": "",
                            placeholder: "请输入小店简介"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_form_item, { label: "联系方式" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input, {
                            value: shopInfo.value.contact,
                            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((shopInfo.value.contact) = $event)),
                            placeholder: "请输入联系方式（如QQ、微信、邮箱等）"
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      (isAdmin.value)
                        ? (_openBlock(), _createBlock(_component_a_form_item, {
                            key: 0,
                            label: "支付模式"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_radio_group, {
                                value: shopInfo.value.order_pay_mode,
                                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((shopInfo.value.order_pay_mode) = $event))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_radio, { value: "tenant" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("自定义支付通道")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_radio, { value: "system" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("系统支付通道")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }, 8, ["value"])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            type: "primary",
                            class: "save-btn",
                            onClick: saveShopInfo,
                            loading: saving.value
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 保存修改 ")
                            ]),
                            _: 1
                          }, 8, ["loading"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"])
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})